export const UPDATE_AFFILIATE_REQUEST = 'UPDATE_AFFILIATE_REQUEST';
export const UPDATE_AFFILIATE_REQUEST_SUCCESS = 'UPDATE_AFFILIATE_REQUEST_SUCCESS';
export const UPDATE_AFFILIATE_REQUEST_FAILURE = 'UPDATE_AFFILIATE_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_update/redux/constants/update_affiliate.constants.js